import UUIDBase from '../UUIDBase'
import { useI18nInstance, localizeFieldName } from '@/plugins/i18n'

const { t } = useI18nInstance().global

export const packI18nMessages = {
    en: {
        enName: 'Name (in Enlgish)',
        arName: 'Name (in Arabic)'
    },
    ar: {
        enName: 'الاسم باللغة الانكليزية',
        arName: 'الاسم باللغة العربية'
    }
}

export default class Pack extends UUIDBase {
    static ENDPOINT = '/inventory/packs'

    enName = ''
    arName = ''
    disabled: boolean = false;

    static from(json: Record<string, unknown> | Pack) {
        return Object.assign(new Pack(), json)
    }

    validateEnName() {
        if (this.enName.length === 0) {
            return t('validation.required', {
                field: localizeFieldName('enName', packI18nMessages)
            })
        } else if (this.enName.length > 255) {
            return t('validation.maxLength', {
                field: localizeFieldName('enName', packI18nMessages)
            })
        }
    }

    validateArName() {
        if (this.arName.length === 0) {
            return t('validation.required', {
                field: localizeFieldName('arName', packI18nMessages)
            })
        } else if (this.arName.length > 255) {
            return t('validation.maxLength', {
                field: localizeFieldName('arName', packI18nMessages)
            })
        }
    }
}
